// @flow

import { Outlet } from 'react-router-dom';

import { Layout } from 'src/components/Layout';

function Presenter(): React.MixedElement {
  return (
    <Layout backgroundColor="surface" lockedOrga showCartSummary>
      <Outlet />
    </Layout>
  );
}

export default Presenter;
